import React, { Component } from "react";
import Data from "../config/data";

import ScrollView from "./ScrollView";
import Content from "./Content";

export default class UserAgreementPage extends Component {
    render() {
        const data = Data.userAgreement;
        return (
            <ScrollView>
                <Content data={data} />
            </ScrollView>
        );
    }

}


// WEBPACK FOOTER //
// ./src/component/agreementpage.js